import React, { FC } from "react";

interface Props {
  query: string;
  setQuery: any;
}

export const FilterQuery: FC<Props> = (props) => {
  const { query, setQuery } = props;
  return (
    <div className="mt-4">
      <div className="ml-sm-2 d-flex align-items-center mt-4 mt-sm-0 mr-4">
        <div className="form-group mb-0">
          <input
            type="text"
            className="form-control"
            name="searchText"
            placeholder="Search"
            value={query}
            onChange={(e) => {
              e.preventDefault();
              setQuery(e.currentTarget.value);
            }}
          />
          <small className="form-text text-muted">
            <b>Search</b> in all fields
          </small>
        </div>
      </div>
    </div>
  );
};
